import '@babel/polyfill';
import Vue from 'vue';
import './assets/VeeValidate/vee-validate';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import { Cropper, Preview } from 'vue-advanced-cropper';
import 'vue-advanced-cropper/dist/style.css';
import frag from 'vue-frag';
import VuePdfEmbed from 'vue-pdf-embed/dist/vue2-pdf-embed';

import App from './App.vue';
import router from './router';
import store from './store';
import '@/plugins/sweetalert';
import '@/plugins/vueFullscreen';
import './permission';
import vuetify from './plugins/vuetify';
import i18n from './plugins/vue-i18n';
import '@/plugins/dialog';

import '@/plugins/apexcharts';
import '@/plugins/ckeditor';
import './filters';

import '@/assets/iconfont/iconfont.css';
import ToggleSearchWrap from './components/layout/ToggleSearchWrap.vue';
import Title from './components/layout/Title.vue';

import DefaultSelect from './components/Select/DefaultSelect.vue';
import DefaultCombobox from './components/combobox/DefaultCombobox.vue';
import DefaultButton from './components/button/DefaultButton.vue';
import FileUploadButton from './components/button/FileUploadButton.vue';
import DefaultIframe from './components/iframe/DefaultIframe.vue';
import DefaultInput from './components/Input/DefaultInput.vue';
import DefaultTable from './components/table/DefaultTable.vue';
import DefaultCheckbox from './components/checkbox/DefaultCheckbox.vue';
import FormSection from './components/form/FormSection.vue';
import FormSectionWrap from './components/form/FormSectionWrap.vue';
import FormBox from './components/form/FormBox.vue';
import FormBoxItem from './components/form/FormBoxItem.vue';
import FormBoxContentsRow from './components/form/FormBoxContentsRow.vue';
import FormBoxContentsRowItem from './components/form/FormBoxContentsRowItem.vue';
import FormSelect from './components/form/FormSelect.vue';
import FormRadioBox from './components/form/FormRadioBox.vue';
import FormInput from './components/form/FormInput.vue';
import FormFooter from './components/form/FormFooter.vue';
import TaiwanDatePicker from './components/datePicker/TaiwanDatePicker.vue';
import SearchBox from './components/search/SearchBox.vue';
import YmsSelect from './components/Select/YmsSelect.vue';
import NoData from './components/layout/NoData.vue';
import PageHeaderBox from './components/page/PageHeaderBox.vue';
import BankSearchDialog from './components/dialog/BankSearchDialog.vue';
import ScrollableDialog from './components/dialog/ScrollableDialog.vue';
import IframeDialog from './components/dialog/IframeDialog.vue';
import DefaultTextarea from './components/textarea/DefaultTextarea.vue';
import CropperBox from './components/box/CropperBox.vue';
import LabelItem from './components/label/LabelItem.vue';
import GridBox from './components/grid/GridBox.vue';
import DefaultCKEditor from './components/CKEditor/DefaultCKEditor.vue';
import AmountInput from './components/Input/AmountInput.vue';
import commonHelper from './mixins/commonHelper';

Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);
Vue.component('VueCropper', Cropper);
Vue.component('VuePreview', Preview);
Vue.component('ToggleSearchWrap', ToggleSearchWrap);
Vue.component('RouteLayoutTitle', Title);
Vue.component('DefaultSelect', DefaultSelect);
Vue.component('DefaultCombobox', DefaultCombobox);
Vue.component('DefaultButton', DefaultButton);
Vue.component('FileUploadButton', FileUploadButton);
Vue.component('DefaultIframe', DefaultIframe);
Vue.component('DefaultInput', DefaultInput);
Vue.component('DefaultTable', DefaultTable);
Vue.component('DefaultCheckbox', DefaultCheckbox);
Vue.component('FormSection', FormSection);
Vue.component('FormSectionWrap', FormSectionWrap);
Vue.component('FormBox', FormBox);
Vue.component('FormBoxItem', FormBoxItem);
Vue.component('FormBoxContentsRow', FormBoxContentsRow);
Vue.component('FormBoxContentsRowItem', FormBoxContentsRowItem);
Vue.component('FormSelect', FormSelect);
Vue.component('FormRadioBox', FormRadioBox);
Vue.component('FormInput', FormInput);
Vue.component('FormFooter', FormFooter);
Vue.component('TaiwanDatePicker', TaiwanDatePicker);
Vue.component('SearchBox', SearchBox);
Vue.component('YmsSelect', YmsSelect);
Vue.component('NoData', NoData);
Vue.component('PageHeaderBox', PageHeaderBox);
Vue.component('BankSearchDialog', BankSearchDialog);
Vue.component('ScrollableDialog', ScrollableDialog);
Vue.component('IframeDialog', IframeDialog);
Vue.component('DefaultTextarea', DefaultTextarea);
Vue.component('CropperBox', CropperBox);
Vue.component('LabelItem', LabelItem);
Vue.component('GridBox', GridBox);
Vue.component('VuePdfEmbed', VuePdfEmbed);
Vue.component('DefaultCKEditor', DefaultCKEditor);
Vue.component('AmountInput', AmountInput);
Vue.mixin(commonHelper);
Vue.directive('frag', frag);
Vue.prototype.$bus = new Vue();

Vue.config.productionTip = false;

if (process.env.NODE_ENV === 'production') {
  Vue.config.devtools = false;
} else {
  Vue.config.devtools = true;
}

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: (h) => h(App),
}).$mount('#app');
